'use client';

import openLanguageDropdownTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentHeader/openLanguageDropdownTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { HeaderDropdown as NextHeaderDropdown } from '@coolblue-development/next-patterns/client';
import { ReactNode } from 'react';

type Props = {
  variant: 'base' | 'unstyled' | 'wide';
  onClose?: () => void;
  buttonChildren: ReactNode;
  children: ReactNode;
};

export const HeaderDropdown = ({ variant, onClose, buttonChildren, children }: Props) => {
  const { trackEvent } = useAnalytics();

  const handleOpen = () => {
    trackEvent(openLanguageDropdownTrigger());
  };

  return (
    <NextHeaderDropdown
      placement='right'
      variant={variant}
      onOpen={handleOpen}
      onClose={onClose}
      buttonChildren={buttonChildren}
    >
      {children}
    </NextHeaderDropdown>
  );
};
